import React, {useState} from "react";

import {Outlet, Navigate} from "react-router"

import Page from "components/Page";

import {ListGoals} from "./components/ListGoals";
import {SelectGoals} from "../../components/Select";
import {WidgetsGoals} from "./components/WidgetDashboard";
import {Shortcuts} from "../../components/Shortcuts";
import {useUser} from "../../store/providers/app";
import {toast} from "react-toastify";

const DashboardGoals = () => {

    const [ selected, setSelected] = useState(null)

    const { user } = useUser()


    if (user.profile !== 1) {
        toast.error('Você não tem permissão para acessar esta área!');
        return <Navigate to="/dashboard/indicators" />
    }

    return (
        <Page label="Painel de metas"  icon="bi bi-grid">
            <div className="card mt-3 shadow-sm border-0">
                <div className="card-body">
                    <div className="row">
                        <div className="col">
                            <SelectGoals handleOnChange={(e) => { setSelected(e) }}/>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-xl-7 order-1 order-xl-0">
                    <ListGoals selected={selected} />
                </div>
                <div className="col-12 col-xl-5 order-0 order-xl-1">
                    <WidgetsGoals/>
                    <Shortcuts />
                </div>
            </div>
            <Outlet/>
        </Page>
    );
}

export default DashboardGoals
